module.exports = __webpack_public_path__ + "static/media/advertorial1.6ae1efe4.png";